import axios from 'axios'
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { useAuth } from '../AuthContext';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import SkelotonEffect from './SkelotonEffect';
import Banner from './Banner';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoArrowBack, IoArrowForward } from 'react-icons/io5';


export default function Home() {
    const { isAuthenticated } = useAuth();
    const userId = localStorage.getItem('userid');
    const [firstObject, setFirstObject] = useState(null);
    const [secondObject, setSecondObject] = useState(null);
    const [thirdObject, setThirdObject] = useState(null);
    const [fourthObject, setFourthObject] = useState(null);
    const [fifthObject, setFifthObject] = useState(null);
    const [sixObject, setSixObject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedBook, setSelectedBook] = useState(null);
    const [error, setError] = useState(null);
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        axios.get(`${baseURL}/homedata/?userid=${userId}&limit=10`, {

            headers: {
                'accept': 'application/json',
                'Authorization': apiKey,
            }
        })
            .then((response) => {

                if (response.data.length > 0) {
                    const firstItem = response.data[0];

                    setFirstObject(firstItem);
                    const secondItem = response.data[1];

                    setSecondObject(secondItem);
                    const thirdItem = response.data[2];

                    setThirdObject(thirdItem);
                    const fourthItem = response.data[3];

                    setFourthObject(fourthItem);
                    const fifthItem = response.data[4];

                    setFifthObject(fifthItem);
                    const sixthItem = response.data[5];

                    setSixObject(sixthItem);

                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setError(error);
            })
            .then(() => {
                setIsLoading(false);
            });

    }, [userId, baseURL, apiKey])

    const openModal = (datav) => {
        setSelectedBook(datav);
        setShowModal(true);
        document.body.classList.add("remove-scroll");
    };

    // Function to close the modal
    const closeModal = () => {
        setShowModal(false);
        setSelectedBook(null);
        document.body.classList.remove("remove-scroll");
    };

    useEffect(() => {
        document.body.classList.remove("remove-scroll");
    }, [location]);

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
    }, []);





    const handleClicknew = () => {
        const fileLink = selectedBook.book_link;
        const bookId = selectedBook._id;
        const fileExtension = fileLink.split('.').pop();

        if (fileExtension === 'pdf') {
            navigate('/pdf', { state: { message: fileLink, id: bookId } });
        } else if (fileExtension === 'epub') {
            navigate('/epub', { state: { message: fileLink, id: bookId } });
        } else {
            console.error('Unsupported file type');
        }
    };

    const handleAgeGroupClick = (ageGroup, ageGroupID) => {
        navigate('/age-group-books', { state: { ageGroup, ageGroupID } });
    };

    const handleGenreClick = (genreID) => {
        navigate('/genre-books', { state: { genreID } });
    };

    const handleLanguageClick = (languageID) => {
        navigate('/language-books', { state: { languageID } });
    };


    const settings = {
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        speed: 800,
        slidesToShow: 7,
        slidesToScroll: 1,
        prevArrow: <IoArrowBack className="icofont-arrow-right dandik" />,
        nextArrow: <IoArrowForward className="icofont-arrow-left bamdik" />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    arrows: true,
                }
            },

        ]
    };


    const renderStars = (rating) => {
        const fullStars = Math.floor(rating); // Full stars (e.g., for 4.5, this is 4)
        const halfStar = rating % 1 >= 0.5;   // True if there's a half star (e.g., for 4.5, this is true)
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0); // Remaining empty stars to make a total of 5 stars

        return (
            <>
                {/* Render full stars */}
                {Array.from({ length: fullStars }, (_, i) => (
                    <i key={`full-${i}`} className="active icofont-star"></i>
                ))}

                {/* Render half star if applicable */}
                {halfStar && <i className="half icofont-star"></i>}

                {/* Render empty stars */}
                {Array.from({ length: emptyStars }, (_, i) => (
                    <i key={`empty-${i}`} className="inactive icofont-star"></i>
                ))}
            </>
        );
    };


    const handleActionClick = () => {
        if (!isAuthenticated) {
            handleReadMoreClick();  // User is not logged in, redirect to login page
        } else {
            handleClicknew();  // User is logged in, proceed with file handling
            document.body.classList.remove("remove-scroll");
        }
    };
    const handleReadMoreClick = () => {
        const fileLink = selectedBook.book_link;
        const bookId = selectedBook._id;
        navigate('/login', { state: { message: fileLink, id: bookId  } });  
    };


    return (
        <>

            <Banner />
            {selectedBook && (
                <>
                    <div className="modal my_modal" style={{ display: showModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000" >
                                <button className="modal-close icofont-close" onClick={closeModal}></button>
                                <div className="product-view">

                                    <div className="col-md-12 col-lg-12">
                                        <div className="row view-gallery">

                                            <div className='col-md-4 col-5'>
                                                <img src={!selectedBook.book_cover_img ? "https://ndl.education.gov.in/upload/book_place_holder.jpg" : selectedBook.book_cover_img} alt="Book Cover" className="img-fluid mb-3 w-100" />
                                            </div>
                                            <div className='col-md-8 col-7'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <h3 className="view-name">
                                                            {selectedBook.book_title}
                                                        </h3>

                                                        <div className='moddal_rating_info'>
                                                            {!!selectedBook.avg_rating && (
                                                                <>
                                                                    {renderStars(selectedBook.avg_rating)}
                                                                    <h4 className="info-ans ms-2">{selectedBook.avg_rating.toFixed(1)}</h4>

                                                                </>
                                                            )}
                                                        </div>

                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className="table_modal">
                                                            <div className="info-authors">

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.author_name && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/authors.png`} alt="authors" /><span className='desktop-view'>Authors</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.author_name}</h4>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.publisher_name && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/publications.png`} alt="publications" /><span className='desktop-view'>publisher</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.publisher_name}</h4>
                                                                    </div>
                                                                )}

                                                            </div>

                                                            <div className="info-authors">
                                                                {selectedBook.book_pages && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/pages.png`} alt="pages" /><span className='desktop-view'>Total Number of pages</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.book_pages}</h4>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.book_year && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/years.png`} alt="years" /><span className='desktop-view'>Book Year </span></h4>
                                                                        <h4 className="info-ans">{selectedBook.book_year}</h4>
                                                                    </div>
                                                                )}
                                                            </div>


                                                            <div className="info-authors">
                                                                {selectedBook.category_name && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/Genre.png`} alt="Genre" /><span className='desktop-view'>Book Category Name </span></h4>
                                                                        <h4 className="info-ans">{selectedBook.category_name}</h4>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.download_count && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/download_count.png`} alt="download count" /><span className='desktop-view'>Download Count</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.download_count}</h4>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="info-authors ">
                                                                {selectedBook.language && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/language.png`} alt="language" /><span className='desktop-view'>Language</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.language}</h4>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className="view-details">
                                                    <h3 className="view-name">
                                                        Book Summary
                                                    </h3>
                                                    <p className="view-desc">{selectedBook.book_desc}</p>
                                                </div>
                                                <div className="info-authorss ">
                                                    <button onClick={handleActionClick} className='btn-6 view-all-btnn mb-3'>Read <i className="fas fa-long-arrow-alt-right"></i></button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}

            {error ? (

                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />

                    </div>
                </section>

            ) : isLoading ? (
                <SkelotonEffect /> // Show loading  while data is being fetched
            ) : (
                <>

                    <div className='container-fluid'>
                        <div className='row'>



                            {fifthObject && (
                                <section className='newly_add_books' id="nutrition">
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='title-heading text-white'>{fifthObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn white-btnn" to="/newly_added_books" >
                                                    View All <i className="fas fa-long-arrow-alt-right"></i>
                                                </NavLink>
                                            </div>


                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {fifthObject.books_data && fifthObject.books_data.map(datav => (
                                                    <div className='col mb-4' key={datav._id}>
                                                        <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                            <div className='product-media'>

                                                                <div className="product-image">
                                                                    <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                        <div className="df-book-wrapper">
                                                                            <div className="df-book-page1">
                                                                            </div>
                                                                            <div className="df-book-page2">
                                                                            </div>
                                                                            <div className="df-book-cover df-icon-play-popup">
                                                                                <img
                                                                                    src={datav.book_cover_img}
                                                                                    className='w-100'
                                                                                    alt="Book Cover"
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        if (!e.currentTarget.dataset.fallback) {
                                                                                            e.currentTarget.dataset.fallback = "true";
                                                                                            e.currentTarget.src = "/assets/images/elements/book_cover.png";
                                                                                        }
                                                                                    }}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className='book-content'>
                                                            <h6 className="book-name text-white">
                                                                {datav.book_title}
                                                            </h6>
                                                            <p>
                                                                <span>Author :</span> {datav.author_name}
                                                            </p>
                                                            <div className="product-rating">
                                                                {renderStars(datav.avg_rating)}
                                                            </div>
                                                            <div className="product-rating">
                                                                <span className='rating-text'>{datav.avg_rating.toFixed(1)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))

                                                }
                                            </div>


                                        </div>
                                    </div>
                                </section>
                            )}

                            {firstObject && (
                                <section id="recommended" className='recom_books'>
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='title-heading'>{firstObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn btn-130" to="/recommended_books" autoFocus={false}>View All <i className="fas fa-long-arrow-alt-right"></i></NavLink>
                                            </div>


                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {firstObject.books_data && firstObject.books_data.map(datav => (

                                                    <div className='col mb-4' key={datav._id}>
                                                        <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                            <div className='product-media'>

                                                                <div className="product-image ">
                                                                    <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                        <div className="df-book-wrapper">
                                                                            <div className="df-book-page1">
                                                                            </div>
                                                                            <div className="df-book-page2">
                                                                            </div>
                                                                            <div className="df-book-cover df-icon-play-popup">
                                                                                <img
                                                                                    src={datav.book_cover_img}
                                                                                    className='w-100'
                                                                                    alt="Book Cover"
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        if (!e.currentTarget.dataset.fallback) {
                                                                                            e.currentTarget.dataset.fallback = "true";
                                                                                            e.currentTarget.src = "/assets/images/elements/book_cover.png";
                                                                                        }
                                                                                    }}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />

                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className='book-content'>
                                                            <h6 className="book-name">
                                                                {datav.book_title}
                                                            </h6>
                                                            <p>
                                                                <span>Author :</span> {datav.author_name}

                                                            </p>
                                                            <div className="product-rating">
                                                                {renderStars(datav.avg_rating)}
                                                            </div>
                                                            <div className="product-rating">
                                                                <span className='rating-text'>{datav.avg_rating.toFixed(1)}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}

                            {secondObject && (
                                <section id="language" className='book-by-language px-0'>
                                    <div className='container space-container'>
                                        <div className='col-md-12 inner_section'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='section-heading mb-0 book-language-title'>{secondObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btn d-none" to="/books_by_language" >
                                                    <span>View All</span>
                                                </NavLink>
                                            </div>

                                            <Slider {...settings} className="brand-slider slider-arrow">
                                                {secondObject.lang_data && secondObject.lang_data.map(datav => (
                                                    <div key={datav._id} className="brand-wrap" onClick={() => handleLanguageClick(datav._id)}>
                                                        <div className="brand-media">
                                                            <h4>{datav.language}</h4>

                                                        </div>

                                                    </div>
                                                ))}
                                            </Slider>


                                        </div>
                                    </div>


                                </section>

                            )}

                            {thirdObject && (
                                <section id="popular" className='popular_books'>
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='title-heading'>{thirdObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn" to="/popular_books" >
                                                    View All <i className="fas fa-long-arrow-alt-right"></i>
                                                </NavLink>
                                            </div>

                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {thirdObject.books_data && thirdObject.books_data.map(datav => (

                                                    <div className='col mb-4' key={datav._id} >
                                                        <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                            <div className='product-media'>

                                                                <div className="product-image">
                                                                    <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                        <div className="df-book-wrapper">
                                                                            <div className="df-book-page1">
                                                                            </div>
                                                                            <div className="df-book-page2">
                                                                            </div>
                                                                            <div className="df-book-cover df-icon-play-popup">
                                                                                <img
                                                                                    src={datav.book_cover_img}
                                                                                    className='w-100'
                                                                                    alt="Book Cover"
                                                                                    loading="lazy"
                                                                                    onError={(e) => {
                                                                                        if (!e.currentTarget.dataset.fallback) {
                                                                                            e.currentTarget.dataset.fallback = "true";
                                                                                            e.currentTarget.src = "/assets/images/elements/book_cover.png";
                                                                                        }
                                                                                    }}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>



                                                        </div>
                                                        <div className='book-content'>
                                                            <h6 className="book-name">
                                                                {datav.book_title}
                                                            </h6>
                                                            <p>
                                                                <span>Author :</span> {datav.author_name}
                                                            </p>
                                                            <div className="product-rating">
                                                                {renderStars(datav.avg_rating)}
                                                            </div>
                                                            <div className="product-rating">
                                                                <span className='rating-text'>{datav.avg_rating.toFixed(1)}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))

                                                }
                                            </div>


                                        </div>
                                    </div>
                                </section>
                            )}

                            <section id="author" className='book-by-language px-0 mt-0 featured-slider'>
                                <div className='container space-container'>
                                    <div className='col-md-12 inner_section'>
                                        <div className='d-flex justify-content-center align-items-center mb-4'>
                                            <h2 className='section-heading mb-0 book-language-title'>Featured Authors</h2>

                                        </div>

                                        <Slider {...settings} className="brand-slider slider-arrow">

                                            <div className="brand-wrap">
                                                <div className="brand-media">

                                                    <h4> <img src="assets/images/authors/AnilKumarSalil.png" title="Anil Kumar 'Salil'" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/ashaprasad.png" loading="lazy" title="Asha Prasad" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/RabindranathTagore.png" loading="lazy" title="Rabindranath Tagore" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/KamalKishoreGoenka.png" loading="lazy" title="Kamal Kishore Goenka" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/MChidanandaMurthy.png" loading="lazy" title="M. Chidananda Murthy" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/nandininayar.png" loading="lazy" title="Nandini Nayar" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/RachnaBholaYamini.png" loading="lazy" title="Rachna Bhola 'Yamini'" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/rameshbijlani.png" loading="lazy" title="Ramesh Bijlani" alt="author" /></h4>
                                                </div>
                                            </div>

                                        </Slider>


                                    </div>
                                </div>


                            </section>

                            {fourthObject && (
                                <section id="gener" className='genre_books'>
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-center align-items-center mb-4'>
                                                <h2 className='title-heading'>{fourthObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn d-none" to="/genre_recommended">
                                                    View All
                                                </NavLink>


                                            </div>

                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {fourthObject.cat_data && fourthObject.cat_data.map((datav, index) => {
                                                    const staticImages = [
                                                        "assets/images/static/image1.png",
                                                        "assets/images/static/image2.png",
                                                        "assets/images/static/image3.png",
                                                        "assets/images/static/image4.png",
                                                        "assets/images/static/image5.png",
                                                        "assets/images/static/image6.png",
                                                        "assets/images/static/image7.png",
                                                        "assets/images/static/image8.png",
                                                        "assets/images/static/image9.png",

                                                    ];

                                                    return (
                                                        <div className='col' key={datav._id} onClick={() => handleGenreClick(datav._id)}>
                                                            <div className="main-div">
                                                                <div className="image-div">
                                                                    <img
                                                                        src={staticImages[index] || "assets/images/elements/books.jpg"}
                                                                        className="w-100"
                                                                        loading="lazy"
                                                                        alt={datav.category_name}
                                                                    />
                                                                </div>
                                                                <div className="text-div">
                                                                    <span className='gener-name'>{datav.category_name}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                </section>
                            )}


                            <section id="publisher" className='book-by-language px-0 mt-0 featured-slider publisher-img'>
                                <div className='container space-container'>
                                    <div className='col-md-12 inner_section'>
                                        <div className='d-flex justify-content-center align-items-center mb-4'>
                                            <h2 className='section-heading mb-0 book-language-title'>Featured Publishers</h2>

                                        </div>

                                        <Slider {...settings} className="brand-slider slider-arrow">

                                            <div className="brand-wrap">
                                                <div className="brand-media">

                                                    <h4> <img src="assets/images/publishers/AmarChitrKatha.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/DiamondBooks.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/Eklavya.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/GitaPressPublication.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/NBT.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/NCERT .png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/SCERTDelhi.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/VidyaVikasAcademy.png" loading="lazy" alt="publishers" /></h4>
                                                </div>
                                            </div>

                                        </Slider>


                                    </div>
                                </div>


                            </section>


                            {sixObject && (
                                <section id="age_group" className='book-by-agegroup book-by-language px-0 mt-3'>
                                    <div className='container'>
                                        <div className='row justify-content-center'>
                                            <div className='col-md-8  books_age_section'>
                                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                                    <h2 className='section-heading mb-0 book-language-title'>{sixObject.title}</h2>
                                                    <NavLink className="btn-6 view-all-btn d-none" rel="noreferrer" to="/books_by_age_group" >
                                                        <span>View All</span>
                                                    </NavLink>
                                                </div>


                                                <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 justify-content-center'>
                                                    {sixObject.agegroup_data && sixObject.agegroup_data.map(datav => (

                                                        <div className='col' key={datav._id} onClick={() => handleAgeGroupClick(datav.agegroup, datav._id)}>

                                                            <div className="brand-wrap">
                                                                <div className="brand-media">
                                                                    <h4> {datav.agegroup}</h4>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    ))

                                                    }
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </section>
                            )}

                        </div>
                    </div>
                </>
            )}
        </>
    )
}
